/* tslint:disable */
/* eslint-disable */
/**
 * Analytics Dashboard
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * 
 * @export
 * @interface ChartDefinition
 */
export interface ChartDefinition {
    /**
     * 
     * @type {string}
     * @memberof ChartDefinition
     */
    'type'?: ChartDefinitionTypeEnum;
    /**
     * 
     * @type {DashboardQuery}
     * @memberof ChartDefinition
     */
    'query': DashboardQuery;
    /**
     * 
     * @type {object}
     * @memberof ChartDefinition
     */
    'chart_definition': object;
}

export const ChartDefinitionTypeEnum = {
    CHART: 'chart'
} as const;

export type ChartDefinitionTypeEnum = typeof ChartDefinitionTypeEnum[keyof typeof ChartDefinitionTypeEnum];

/**
 * 
 * @export
 * @interface DashboardAttributes
 */
export interface DashboardAttributes {
    /**
     * 
     * @type {number}
     * @memberof DashboardAttributes
     */
    'version': number;
    /**
     * 
     * @type {{ [key: string]: Pin; }}
     * @memberof DashboardAttributes
     */
    'pins': { [key: string]: Pin; };
    /**
     * 
     * @type {Array<DashboardMember>}
     * @memberof DashboardAttributes
     */
    'members': Array<DashboardMember>;
    /**
     * 
     * @type {string}
     * @memberof DashboardAttributes
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DashboardAttributes
     */
    'icon'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DashboardAttributes
     */
    'created_at'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DashboardAttributes
     */
    'created_by'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DashboardAttributes
     */
    'updated_at'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DashboardAttributes
     */
    'updated_by'?: string | null;
}
/**
 * Attributes for a dashboard in the list view.
 * @export
 * @interface DashboardListItemAttributes
 */
export interface DashboardListItemAttributes {
    /**
     * 
     * @type {Array<DashboardMember>}
     * @memberof DashboardListItemAttributes
     */
    'members': Array<DashboardMember>;
    /**
     * 
     * @type {string}
     * @memberof DashboardListItemAttributes
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DashboardListItemAttributes
     */
    'icon'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DashboardListItemAttributes
     */
    'created_at'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DashboardListItemAttributes
     */
    'created_by'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DashboardListItemAttributes
     */
    'updated_at'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DashboardListItemAttributes
     */
    'updated_by'?: string | null;
}
/**
 * 
 * @export
 * @interface DashboardListResponse
 */
export interface DashboardListResponse {
    /**
     * 
     * @type {Array<JsonApiResourceObjectDashboardListItemAttributesBaseModel>}
     * @memberof DashboardListResponse
     */
    'data': Array<JsonApiResourceObjectDashboardListItemAttributesBaseModel>;
    /**
     * 
     * @type {object}
     * @memberof DashboardListResponse
     */
    'meta'?: object;
    /**
     * 
     * @type {JsonApiSuccessPaginationLinks}
     * @memberof DashboardListResponse
     */
    'links': JsonApiSuccessPaginationLinks;
    /**
     * 
     * @type {Array<JsonApiResourceObjectBaseModelBaseModel>}
     * @memberof DashboardListResponse
     */
    'included'?: Array<JsonApiResourceObjectBaseModelBaseModel> | null;
}
/**
 * A user who is a member of a dashboard.
 * @export
 * @interface DashboardMember
 */
export interface DashboardMember {
    /**
     * 
     * @type {string}
     * @memberof DashboardMember
     */
    'type': DashboardMemberTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof DashboardMember
     */
    'id': string;
}

export const DashboardMemberTypeEnum = {
    USER: 'user'
} as const;

export type DashboardMemberTypeEnum = typeof DashboardMemberTypeEnum[keyof typeof DashboardMemberTypeEnum];

/**
 * 
 * @export
 * @interface DashboardPatchAttributes
 */
export interface DashboardPatchAttributes {
    /**
     * 
     * @type {{ [key: string]: Pin; }}
     * @memberof DashboardPatchAttributes
     */
    'pins': { [key: string]: Pin; };
    /**
     * 
     * @type {Array<DashboardMember>}
     * @memberof DashboardPatchAttributes
     */
    'members'?: Array<DashboardMember> | null;
    /**
     * 
     * @type {string}
     * @memberof DashboardPatchAttributes
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DashboardPatchAttributes
     */
    'icon'?: string | null;
}
/**
 * 
 * @export
 * @interface DashboardPatchData
 */
export interface DashboardPatchData {
    /**
     * 
     * @type {string}
     * @memberof DashboardPatchData
     */
    'type': DashboardPatchDataTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof DashboardPatchData
     */
    'id': string;
    /**
     * 
     * @type {DashboardPatchAttributes}
     * @memberof DashboardPatchData
     */
    'attributes': DashboardPatchAttributes;
}

export const DashboardPatchDataTypeEnum = {
    DASHBOARDS: 'dashboards'
} as const;

export type DashboardPatchDataTypeEnum = typeof DashboardPatchDataTypeEnum[keyof typeof DashboardPatchDataTypeEnum];

/**
 * 
 * @export
 * @interface DashboardPatchRequest
 */
export interface DashboardPatchRequest {
    /**
     * 
     * @type {DashboardPatchData}
     * @memberof DashboardPatchRequest
     */
    'data': DashboardPatchData;
}
/**
 * 
 * @export
 * @interface DashboardQuery
 */
export interface DashboardQuery {
    /**
     * 
     * @type {string}
     * @memberof DashboardQuery
     */
    'query': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof DashboardQuery
     */
    'parameters'?: Array<string>;
}
/**
 * 
 * @export
 * @interface DashboardResponse
 */
export interface DashboardResponse {
    /**
     * 
     * @type {JsonApiResourceObjectDashboardAttributesBaseModel}
     * @memberof DashboardResponse
     */
    'data': JsonApiResourceObjectDashboardAttributesBaseModel;
    /**
     * 
     * @type {object}
     * @memberof DashboardResponse
     */
    'meta'?: object;
    /**
     * 
     * @type {JsonApiSuccessResponseLinks}
     * @memberof DashboardResponse
     */
    'links': JsonApiSuccessResponseLinks;
    /**
     * 
     * @type {Array<JsonApiResourceObjectBaseModelBaseModel>}
     * @memberof DashboardResponse
     */
    'included'?: Array<JsonApiResourceObjectBaseModelBaseModel> | null;
}
/**
 * 
 * @export
 * @interface Data
 */
export interface Data {
    /**
     * 
     * @type {string}
     * @memberof Data
     */
    'type': string;
    /**
     * 
     * @type {string}
     * @memberof Data
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof Data
     */
    'lid'?: string;
}
/**
 * 
 * @export
 * @interface HTTPValidationError
 */
export interface HTTPValidationError {
    /**
     * 
     * @type {Array<ValidationError>}
     * @memberof HTTPValidationError
     */
    'detail'?: Array<ValidationError>;
}
/**
 * 
 * @export
 * @interface Id
 */
export interface Id {
}
/**
 * Resource identifier object
 * @export
 * @interface JsonApiIdentifier
 */
export interface JsonApiIdentifier {
    /**
     * 
     * @type {string}
     * @memberof JsonApiIdentifier
     */
    'type': string;
    /**
     * 
     * @type {string}
     * @memberof JsonApiIdentifier
     */
    'id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof JsonApiIdentifier
     */
    'lid'?: string | null;
}
/**
 * A relationship object.
 * @export
 * @interface JsonApiRelationship
 */
export interface JsonApiRelationship {
    /**
     * 
     * @type {Data}
     * @memberof JsonApiRelationship
     */
    'data'?: Data | null;
}
/**
 * 
 * @export
 * @interface JsonApiResourceObjectBaseModelBaseModel
 */
export interface JsonApiResourceObjectBaseModelBaseModel {
    /**
     * 
     * @type {string}
     * @memberof JsonApiResourceObjectBaseModelBaseModel
     */
    'type': string;
    /**
     * 
     * @type {Id}
     * @memberof JsonApiResourceObjectBaseModelBaseModel
     */
    'id': Id;
    /**
     * 
     * @type {object}
     * @memberof JsonApiResourceObjectBaseModelBaseModel
     */
    'attributes': object;
    /**
     * 
     * @type {object}
     * @memberof JsonApiResourceObjectBaseModelBaseModel
     */
    'meta'?: object;
    /**
     * 
     * @type {{ [key: string]: JsonApiRelationship; }}
     * @memberof JsonApiResourceObjectBaseModelBaseModel
     */
    'relationships'?: { [key: string]: JsonApiRelationship; } | null;
}
/**
 * 
 * @export
 * @interface JsonApiResourceObjectDashboardAttributesBaseModel
 */
export interface JsonApiResourceObjectDashboardAttributesBaseModel {
    /**
     * 
     * @type {string}
     * @memberof JsonApiResourceObjectDashboardAttributesBaseModel
     */
    'type': string;
    /**
     * 
     * @type {Id}
     * @memberof JsonApiResourceObjectDashboardAttributesBaseModel
     */
    'id': Id;
    /**
     * 
     * @type {DashboardAttributes}
     * @memberof JsonApiResourceObjectDashboardAttributesBaseModel
     */
    'attributes': DashboardAttributes;
    /**
     * 
     * @type {object}
     * @memberof JsonApiResourceObjectDashboardAttributesBaseModel
     */
    'meta'?: object;
    /**
     * 
     * @type {{ [key: string]: JsonApiRelationship; }}
     * @memberof JsonApiResourceObjectDashboardAttributesBaseModel
     */
    'relationships'?: { [key: string]: JsonApiRelationship; } | null;
}
/**
 * 
 * @export
 * @interface JsonApiResourceObjectDashboardListItemAttributesBaseModel
 */
export interface JsonApiResourceObjectDashboardListItemAttributesBaseModel {
    /**
     * 
     * @type {string}
     * @memberof JsonApiResourceObjectDashboardListItemAttributesBaseModel
     */
    'type': string;
    /**
     * 
     * @type {Id}
     * @memberof JsonApiResourceObjectDashboardListItemAttributesBaseModel
     */
    'id': Id;
    /**
     * 
     * @type {DashboardListItemAttributes}
     * @memberof JsonApiResourceObjectDashboardListItemAttributesBaseModel
     */
    'attributes': DashboardListItemAttributes;
    /**
     * 
     * @type {object}
     * @memberof JsonApiResourceObjectDashboardListItemAttributesBaseModel
     */
    'meta'?: object;
    /**
     * 
     * @type {{ [key: string]: JsonApiRelationship; }}
     * @memberof JsonApiResourceObjectDashboardListItemAttributesBaseModel
     */
    'relationships'?: { [key: string]: JsonApiRelationship; } | null;
}
/**
 * A JSON:API compliant response.
 * @export
 * @interface JsonApiSuccessPaginationLinks
 */
export interface JsonApiSuccessPaginationLinks {
    /**
     * 
     * @type {string}
     * @memberof JsonApiSuccessPaginationLinks
     */
    'self': string;
    /**
     * 
     * @type {string}
     * @memberof JsonApiSuccessPaginationLinks
     */
    'next'?: string | null;
}
/**
 * A JSON:API compliant response.
 * @export
 * @interface JsonApiSuccessResponseLinks
 */
export interface JsonApiSuccessResponseLinks {
    /**
     * 
     * @type {string}
     * @memberof JsonApiSuccessResponseLinks
     */
    'self': string;
}
/**
 * 
 * @export
 * @interface Pin
 */
export interface Pin {
    /**
     * 
     * @type {string}
     * @memberof Pin
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof Pin
     */
    'title'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Pin
     */
    'description'?: string | null;
    /**
     * 
     * @type {PinLayout}
     * @memberof Pin
     */
    'layout': PinLayout;
    /**
     * 
     * @type {ChartDefinition}
     * @memberof Pin
     */
    'definition': ChartDefinition;
    /**
     * 
     * @type {string}
     * @memberof Pin
     */
    'created_at'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Pin
     */
    'created_by'?: string | null;
}
/**
 * 
 * @export
 * @interface PinLayout
 */
export interface PinLayout {
    /**
     * 
     * @type {number}
     * @memberof PinLayout
     */
    'column': number;
    /**
     * 
     * @type {number}
     * @memberof PinLayout
     */
    'row': number;
    /**
     * 
     * @type {number}
     * @memberof PinLayout
     */
    'width': number;
    /**
     * 
     * @type {number}
     * @memberof PinLayout
     */
    'height': number;
}
/**
 * The kind of entity a dashboard is scoped to.
 * @export
 * @enum {string}
 */

export const Realm = {
    FLOWS: 'flows',
    CASE_ANALYTICS: 'case_analytics',
    WORKSPACE: 'workspace'
} as const;

export type Realm = typeof Realm[keyof typeof Realm];


/**
 * 
 * @export
 * @interface ValidationError
 */
export interface ValidationError {
    /**
     * 
     * @type {Array<ValidationErrorLocInner>}
     * @memberof ValidationError
     */
    'loc': Array<ValidationErrorLocInner>;
    /**
     * 
     * @type {string}
     * @memberof ValidationError
     */
    'msg': string;
    /**
     * 
     * @type {string}
     * @memberof ValidationError
     */
    'type': string;
}
/**
 * 
 * @export
 * @interface ValidationErrorLocInner
 */
export interface ValidationErrorLocInner {
}

/**
 * DefaultApi - axios parameter creator
 * @export
 */
export const DefaultApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Delete Dashboard
         * @param {Realm} realm 
         * @param {string} realmId 
         * @param {string} dashboardId 
         * @param {string | null} [ifMatch] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDashboardDashboardsApiV1RealmRealmIdDashboardsDashboardIdDelete: async (realm: Realm, realmId: string, dashboardId: string, ifMatch?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'realm' is not null or undefined
            assertParamExists('deleteDashboardDashboardsApiV1RealmRealmIdDashboardsDashboardIdDelete', 'realm', realm)
            // verify required parameter 'realmId' is not null or undefined
            assertParamExists('deleteDashboardDashboardsApiV1RealmRealmIdDashboardsDashboardIdDelete', 'realmId', realmId)
            // verify required parameter 'dashboardId' is not null or undefined
            assertParamExists('deleteDashboardDashboardsApiV1RealmRealmIdDashboardsDashboardIdDelete', 'dashboardId', dashboardId)
            const localVarPath = `/dashboards/api/v1/{realm}/{realm_id}/dashboards/{dashboard_id}`
                .replace(`{${"realm"}}`, encodeURIComponent(String(realm)))
                .replace(`{${"realm_id"}}`, encodeURIComponent(String(realmId)))
                .replace(`{${"dashboard_id"}}`, encodeURIComponent(String(dashboardId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            if (ifMatch != null) {
                localVarHeaderParameter['if-match'] = String(ifMatch);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Dashboard
         * @param {Realm} realm 
         * @param {string} realmId 
         * @param {string} dashboardId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDashboardDashboardsApiV1RealmRealmIdDashboardsDashboardIdGet: async (realm: Realm, realmId: string, dashboardId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'realm' is not null or undefined
            assertParamExists('getDashboardDashboardsApiV1RealmRealmIdDashboardsDashboardIdGet', 'realm', realm)
            // verify required parameter 'realmId' is not null or undefined
            assertParamExists('getDashboardDashboardsApiV1RealmRealmIdDashboardsDashboardIdGet', 'realmId', realmId)
            // verify required parameter 'dashboardId' is not null or undefined
            assertParamExists('getDashboardDashboardsApiV1RealmRealmIdDashboardsDashboardIdGet', 'dashboardId', dashboardId)
            const localVarPath = `/dashboards/api/v1/{realm}/{realm_id}/dashboards/{dashboard_id}`
                .replace(`{${"realm"}}`, encodeURIComponent(String(realm)))
                .replace(`{${"realm_id"}}`, encodeURIComponent(String(realmId)))
                .replace(`{${"dashboard_id"}}`, encodeURIComponent(String(dashboardId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Info
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        infoAnalyticsInfoGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/analytics/_info`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Info
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        infoInfoGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/_info`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List Dashboards
         * @param {Realm} realm 
         * @param {string} realmId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listDashboardsDashboardsApiV1RealmRealmIdDashboardsGet: async (realm: Realm, realmId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'realm' is not null or undefined
            assertParamExists('listDashboardsDashboardsApiV1RealmRealmIdDashboardsGet', 'realm', realm)
            // verify required parameter 'realmId' is not null or undefined
            assertParamExists('listDashboardsDashboardsApiV1RealmRealmIdDashboardsGet', 'realmId', realmId)
            const localVarPath = `/dashboards/api/v1/{realm}/{realm_id}/dashboards`
                .replace(`{${"realm"}}`, encodeURIComponent(String(realm)))
                .replace(`{${"realm_id"}}`, encodeURIComponent(String(realmId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Patch Dashboard
         * @param {Realm} realm 
         * @param {string} realmId 
         * @param {string} dashboardId 
         * @param {DashboardPatchRequest} dashboardPatchRequest 
         * @param {string | null} [ifMatch] 
         * @param {string | null} [ifNoneMatch] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchDashboardDashboardsApiV1RealmRealmIdDashboardsDashboardIdPatch: async (realm: Realm, realmId: string, dashboardId: string, dashboardPatchRequest: DashboardPatchRequest, ifMatch?: string | null, ifNoneMatch?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'realm' is not null or undefined
            assertParamExists('patchDashboardDashboardsApiV1RealmRealmIdDashboardsDashboardIdPatch', 'realm', realm)
            // verify required parameter 'realmId' is not null or undefined
            assertParamExists('patchDashboardDashboardsApiV1RealmRealmIdDashboardsDashboardIdPatch', 'realmId', realmId)
            // verify required parameter 'dashboardId' is not null or undefined
            assertParamExists('patchDashboardDashboardsApiV1RealmRealmIdDashboardsDashboardIdPatch', 'dashboardId', dashboardId)
            // verify required parameter 'dashboardPatchRequest' is not null or undefined
            assertParamExists('patchDashboardDashboardsApiV1RealmRealmIdDashboardsDashboardIdPatch', 'dashboardPatchRequest', dashboardPatchRequest)
            const localVarPath = `/dashboards/api/v1/{realm}/{realm_id}/dashboards/{dashboard_id}`
                .replace(`{${"realm"}}`, encodeURIComponent(String(realm)))
                .replace(`{${"realm_id"}}`, encodeURIComponent(String(realmId)))
                .replace(`{${"dashboard_id"}}`, encodeURIComponent(String(dashboardId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (ifMatch != null) {
                localVarHeaderParameter['if-match'] = String(ifMatch);
            }
            if (ifNoneMatch != null) {
                localVarHeaderParameter['if-none-match'] = String(ifNoneMatch);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(dashboardPatchRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DefaultApi - functional programming interface
 * @export
 */
export const DefaultApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DefaultApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Delete Dashboard
         * @param {Realm} realm 
         * @param {string} realmId 
         * @param {string} dashboardId 
         * @param {string | null} [ifMatch] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteDashboardDashboardsApiV1RealmRealmIdDashboardsDashboardIdDelete(realm: Realm, realmId: string, dashboardId: string, ifMatch?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteDashboardDashboardsApiV1RealmRealmIdDashboardsDashboardIdDelete(realm, realmId, dashboardId, ifMatch, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.deleteDashboardDashboardsApiV1RealmRealmIdDashboardsDashboardIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Dashboard
         * @param {Realm} realm 
         * @param {string} realmId 
         * @param {string} dashboardId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDashboardDashboardsApiV1RealmRealmIdDashboardsDashboardIdGet(realm: Realm, realmId: string, dashboardId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DashboardResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDashboardDashboardsApiV1RealmRealmIdDashboardsDashboardIdGet(realm, realmId, dashboardId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getDashboardDashboardsApiV1RealmRealmIdDashboardsDashboardIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Info
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async infoAnalyticsInfoGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: string | null; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.infoAnalyticsInfoGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.infoAnalyticsInfoGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Info
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async infoInfoGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: string | null; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.infoInfoGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.infoInfoGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List Dashboards
         * @param {Realm} realm 
         * @param {string} realmId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listDashboardsDashboardsApiV1RealmRealmIdDashboardsGet(realm: Realm, realmId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DashboardListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listDashboardsDashboardsApiV1RealmRealmIdDashboardsGet(realm, realmId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.listDashboardsDashboardsApiV1RealmRealmIdDashboardsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Patch Dashboard
         * @param {Realm} realm 
         * @param {string} realmId 
         * @param {string} dashboardId 
         * @param {DashboardPatchRequest} dashboardPatchRequest 
         * @param {string | null} [ifMatch] 
         * @param {string | null} [ifNoneMatch] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchDashboardDashboardsApiV1RealmRealmIdDashboardsDashboardIdPatch(realm: Realm, realmId: string, dashboardId: string, dashboardPatchRequest: DashboardPatchRequest, ifMatch?: string | null, ifNoneMatch?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DashboardResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchDashboardDashboardsApiV1RealmRealmIdDashboardsDashboardIdPatch(realm, realmId, dashboardId, dashboardPatchRequest, ifMatch, ifNoneMatch, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.patchDashboardDashboardsApiV1RealmRealmIdDashboardsDashboardIdPatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DefaultApi - factory interface
 * @export
 */
export const DefaultApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DefaultApiFp(configuration)
    return {
        /**
         * 
         * @summary Delete Dashboard
         * @param {DefaultApiDeleteDashboardDashboardsApiV1RealmRealmIdDashboardsDashboardIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDashboardDashboardsApiV1RealmRealmIdDashboardsDashboardIdDelete(requestParameters: DefaultApiDeleteDashboardDashboardsApiV1RealmRealmIdDashboardsDashboardIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteDashboardDashboardsApiV1RealmRealmIdDashboardsDashboardIdDelete(requestParameters.realm, requestParameters.realmId, requestParameters.dashboardId, requestParameters.ifMatch, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Dashboard
         * @param {DefaultApiGetDashboardDashboardsApiV1RealmRealmIdDashboardsDashboardIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDashboardDashboardsApiV1RealmRealmIdDashboardsDashboardIdGet(requestParameters: DefaultApiGetDashboardDashboardsApiV1RealmRealmIdDashboardsDashboardIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<DashboardResponse> {
            return localVarFp.getDashboardDashboardsApiV1RealmRealmIdDashboardsDashboardIdGet(requestParameters.realm, requestParameters.realmId, requestParameters.dashboardId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Info
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        infoAnalyticsInfoGet(options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: string | null; }> {
            return localVarFp.infoAnalyticsInfoGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Info
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        infoInfoGet(options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: string | null; }> {
            return localVarFp.infoInfoGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List Dashboards
         * @param {DefaultApiListDashboardsDashboardsApiV1RealmRealmIdDashboardsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listDashboardsDashboardsApiV1RealmRealmIdDashboardsGet(requestParameters: DefaultApiListDashboardsDashboardsApiV1RealmRealmIdDashboardsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<DashboardListResponse> {
            return localVarFp.listDashboardsDashboardsApiV1RealmRealmIdDashboardsGet(requestParameters.realm, requestParameters.realmId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Patch Dashboard
         * @param {DefaultApiPatchDashboardDashboardsApiV1RealmRealmIdDashboardsDashboardIdPatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchDashboardDashboardsApiV1RealmRealmIdDashboardsDashboardIdPatch(requestParameters: DefaultApiPatchDashboardDashboardsApiV1RealmRealmIdDashboardsDashboardIdPatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<DashboardResponse> {
            return localVarFp.patchDashboardDashboardsApiV1RealmRealmIdDashboardsDashboardIdPatch(requestParameters.realm, requestParameters.realmId, requestParameters.dashboardId, requestParameters.dashboardPatchRequest, requestParameters.ifMatch, requestParameters.ifNoneMatch, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for deleteDashboardDashboardsApiV1RealmRealmIdDashboardsDashboardIdDelete operation in DefaultApi.
 * @export
 * @interface DefaultApiDeleteDashboardDashboardsApiV1RealmRealmIdDashboardsDashboardIdDeleteRequest
 */
export interface DefaultApiDeleteDashboardDashboardsApiV1RealmRealmIdDashboardsDashboardIdDeleteRequest {
    /**
     * 
     * @type {Realm}
     * @memberof DefaultApiDeleteDashboardDashboardsApiV1RealmRealmIdDashboardsDashboardIdDelete
     */
    readonly realm: Realm

    /**
     * 
     * @type {string}
     * @memberof DefaultApiDeleteDashboardDashboardsApiV1RealmRealmIdDashboardsDashboardIdDelete
     */
    readonly realmId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiDeleteDashboardDashboardsApiV1RealmRealmIdDashboardsDashboardIdDelete
     */
    readonly dashboardId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiDeleteDashboardDashboardsApiV1RealmRealmIdDashboardsDashboardIdDelete
     */
    readonly ifMatch?: string | null
}

/**
 * Request parameters for getDashboardDashboardsApiV1RealmRealmIdDashboardsDashboardIdGet operation in DefaultApi.
 * @export
 * @interface DefaultApiGetDashboardDashboardsApiV1RealmRealmIdDashboardsDashboardIdGetRequest
 */
export interface DefaultApiGetDashboardDashboardsApiV1RealmRealmIdDashboardsDashboardIdGetRequest {
    /**
     * 
     * @type {Realm}
     * @memberof DefaultApiGetDashboardDashboardsApiV1RealmRealmIdDashboardsDashboardIdGet
     */
    readonly realm: Realm

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetDashboardDashboardsApiV1RealmRealmIdDashboardsDashboardIdGet
     */
    readonly realmId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetDashboardDashboardsApiV1RealmRealmIdDashboardsDashboardIdGet
     */
    readonly dashboardId: string
}

/**
 * Request parameters for listDashboardsDashboardsApiV1RealmRealmIdDashboardsGet operation in DefaultApi.
 * @export
 * @interface DefaultApiListDashboardsDashboardsApiV1RealmRealmIdDashboardsGetRequest
 */
export interface DefaultApiListDashboardsDashboardsApiV1RealmRealmIdDashboardsGetRequest {
    /**
     * 
     * @type {Realm}
     * @memberof DefaultApiListDashboardsDashboardsApiV1RealmRealmIdDashboardsGet
     */
    readonly realm: Realm

    /**
     * 
     * @type {string}
     * @memberof DefaultApiListDashboardsDashboardsApiV1RealmRealmIdDashboardsGet
     */
    readonly realmId: string
}

/**
 * Request parameters for patchDashboardDashboardsApiV1RealmRealmIdDashboardsDashboardIdPatch operation in DefaultApi.
 * @export
 * @interface DefaultApiPatchDashboardDashboardsApiV1RealmRealmIdDashboardsDashboardIdPatchRequest
 */
export interface DefaultApiPatchDashboardDashboardsApiV1RealmRealmIdDashboardsDashboardIdPatchRequest {
    /**
     * 
     * @type {Realm}
     * @memberof DefaultApiPatchDashboardDashboardsApiV1RealmRealmIdDashboardsDashboardIdPatch
     */
    readonly realm: Realm

    /**
     * 
     * @type {string}
     * @memberof DefaultApiPatchDashboardDashboardsApiV1RealmRealmIdDashboardsDashboardIdPatch
     */
    readonly realmId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiPatchDashboardDashboardsApiV1RealmRealmIdDashboardsDashboardIdPatch
     */
    readonly dashboardId: string

    /**
     * 
     * @type {DashboardPatchRequest}
     * @memberof DefaultApiPatchDashboardDashboardsApiV1RealmRealmIdDashboardsDashboardIdPatch
     */
    readonly dashboardPatchRequest: DashboardPatchRequest

    /**
     * 
     * @type {string}
     * @memberof DefaultApiPatchDashboardDashboardsApiV1RealmRealmIdDashboardsDashboardIdPatch
     */
    readonly ifMatch?: string | null

    /**
     * 
     * @type {string}
     * @memberof DefaultApiPatchDashboardDashboardsApiV1RealmRealmIdDashboardsDashboardIdPatch
     */
    readonly ifNoneMatch?: string | null
}

/**
 * DefaultApi - object-oriented interface
 * @export
 * @class DefaultApi
 * @extends {BaseAPI}
 */
export class DefaultApi extends BaseAPI {
    /**
     * 
     * @summary Delete Dashboard
     * @param {DefaultApiDeleteDashboardDashboardsApiV1RealmRealmIdDashboardsDashboardIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public deleteDashboardDashboardsApiV1RealmRealmIdDashboardsDashboardIdDelete(requestParameters: DefaultApiDeleteDashboardDashboardsApiV1RealmRealmIdDashboardsDashboardIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).deleteDashboardDashboardsApiV1RealmRealmIdDashboardsDashboardIdDelete(requestParameters.realm, requestParameters.realmId, requestParameters.dashboardId, requestParameters.ifMatch, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Dashboard
     * @param {DefaultApiGetDashboardDashboardsApiV1RealmRealmIdDashboardsDashboardIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getDashboardDashboardsApiV1RealmRealmIdDashboardsDashboardIdGet(requestParameters: DefaultApiGetDashboardDashboardsApiV1RealmRealmIdDashboardsDashboardIdGetRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getDashboardDashboardsApiV1RealmRealmIdDashboardsDashboardIdGet(requestParameters.realm, requestParameters.realmId, requestParameters.dashboardId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Info
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public infoAnalyticsInfoGet(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).infoAnalyticsInfoGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Info
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public infoInfoGet(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).infoInfoGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List Dashboards
     * @param {DefaultApiListDashboardsDashboardsApiV1RealmRealmIdDashboardsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public listDashboardsDashboardsApiV1RealmRealmIdDashboardsGet(requestParameters: DefaultApiListDashboardsDashboardsApiV1RealmRealmIdDashboardsGetRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).listDashboardsDashboardsApiV1RealmRealmIdDashboardsGet(requestParameters.realm, requestParameters.realmId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Patch Dashboard
     * @param {DefaultApiPatchDashboardDashboardsApiV1RealmRealmIdDashboardsDashboardIdPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public patchDashboardDashboardsApiV1RealmRealmIdDashboardsDashboardIdPatch(requestParameters: DefaultApiPatchDashboardDashboardsApiV1RealmRealmIdDashboardsDashboardIdPatchRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).patchDashboardDashboardsApiV1RealmRealmIdDashboardsDashboardIdPatch(requestParameters.realm, requestParameters.realmId, requestParameters.dashboardId, requestParameters.dashboardPatchRequest, requestParameters.ifMatch, requestParameters.ifNoneMatch, options).then((request) => request(this.axios, this.basePath));
    }
}



